import { getFetchedDataPayload } from '@vista-digital/utilities';
import { loyaltyDomainStore } from '../../../store';
export const getLoyaltyGenreById = (genreId) => {
    return getFetchedDataPayload(loyaltyDomainStore.data.genresById[genreId]);
};
//# sourceMappingURL=get-loyalty-genre-by-id.js.map